import { inject, Injectable } from '@angular/core';
import { PolicityCookieModalComponent } from '../components/policity-cookie-modal/policity-cookie-modal.component';
import { ModalData, ModalOption } from '../type/modal';
import { GenericModalComponent } from '../components/generic-modal/generic-modal.component';
import { ModalController } from '@ionic/angular/standalone';
import { ManagementsActionsModalComponent } from '../../my-managements/managements-actions-modal/managements-actions-modal.component';
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _modalController: ModalController = inject(ModalController);

  successModalData = (action: () => void): ModalData => {
    return {
      icon: 'icon-circulo-ok',
      title: 'general-modal.success-title',
      dismissButton: { label: 'error.modal.close', action: () => action() },
      rigthButton: { label: 'error.modal.close', action: () => action() },
    };
  };

  errorModalData = (action: () => void): ModalData => {
    return {
      icon: 'icon-circulo-error',
      title: 'error.modal.title',
      rigthButton: { label: 'error.modal.close', action: () => action() },
    };
  };

  downloadModalData = (action: () => void): ModalData => {
    return {
      icon: 'icon-information-circle',
      title: 'general-modal.download-title',
      subtitle: 'general-modal.download-subtitle',
      rigthButton: { label: 'general-modal.close', action: () => action() },
    };
  };

  async openActionsManagementsModal(modalOption: ModalOption) {
    const modal = await this._modalController.create({
      component: ManagementsActionsModalComponent,
      componentProps: {
        modalOption: modalOption
      },
    });
    await modal.present();
    return modal;
  }

  async openPolicityCookieModal() {
    const modal = await this._modalController.create({
      component: PolicityCookieModalComponent,
    });
    return await modal.present();
  }

  async openGenericModal(modalData: ModalData) {
    const modal = await this._modalController.create({
      component: GenericModalComponent,
      componentProps: {
        modalData: modalData,
      },
    });
    await modal.present();
    return modal;
  }

  showSuccessModalService(action: () => void): void {
    this.openGenericModal(
      this.successModalData(() => {
        action();
      })
    );
  }

  showErrorModalService(action: () => void): void {
    this.openGenericModal(
      this.errorModalData(() => {
        action();
      })
    );
  }

  showDownloadModalService(action: () => void): void {
    this.openGenericModal(
      this.downloadModalData(() => {
        action();
      })
    );
  }
}
